import Grid from '@mui/material/Grid';
import StaffMemberInformationCard from 'pages/AnnualUserAccessReview/components/StaffMemberInformation/StaffMemberInformationCard';
import { WQAccordion } from 'components/UI/WQAccordion/WQAccordion';

const UserInformationHeader = ({
	userData,
	...props
}) => {
	
	return (
		<>
			{/* <Base> */}
			<Grid container spacing={5} p={5}>
				<Grid item xs={12}>
					<WQAccordion
						coloredHeader
						title={userData.firstName + ' ' + userData.lastName}
					>
						<StaffMemberInformationCard staffMember={userData} />
					</WQAccordion>
				</Grid>
			</Grid>
			{/* </Base> */}
		</>
	);
};

export default UserInformationHeader;
